import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-toggle-cell-renderer',
  templateUrl: './ag-toggle-cell-renderer.component.html',
  styleUrl: './ag-toggle-cell-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AgToggleCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  idPath: number;
  status: boolean;
  action: Function;
  id: number;

  constructor() {}

  agInit(params: any): void {
    this.params = params;
    const property = params.property;
    this.idPath = params.idPath;
    this.id = params.idPath;
    this.status = params?.data?.[property];
    this.action = params.action;
  }

  refresh(params: any): boolean {
    this.params = params;
    const property = params.property;
    this.idPath = params.idPath;
    this.id = params.idPath;
    this.status = params?.data?.[property];
    this.action = params.action;

    return true;
  }

  clickAction(params: any) {
    event.preventDefault();
    this.action(params);
  }
}
